<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('tasks')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openCreate"
          >
            {{ $t("new_task") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

    <task-viewmodal
      v-if="isViewTasKModalActive"
      @close-modal="closeViewTaskModal"
      :id="id"
    />

    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="delete-task-confirmation"
      @confirmed="deleteTask"
      @cancelled="cancelled"
    />
    
  <!--Task Reminder Modal-->
    <task-reminder
      v-if="isTaskReminderModalActive"
      modal-id="reminder-Modal"
      :taskId="task_id"
      @afterSubmitDone="reloadAllState"
      @close-modal="isTaskReminderModalActive = false"
    />

  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../core/helpers/app/AppFunction";
import {CREATE_DUPLICATE_TASK} from "../../../../Config/ApiUrl";
import {axiosDelete, axiosPost} from "@/app/Helpers/AxiosHelper";

export default {
  extends: CoreLibrary,
  name: "Tasks",
  mixins: [TableHelpers],
  data() {
    return {
      id:0,
      isViewTasKModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      isTaskReminderModalActive: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.TASK_LISTING,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("task"),
            type: "custom-html",
            key: "title",
            modifier: (value, row) => {
                return `<a href="#" id="${row.id}" data-attribute="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`; 
            },
          },
          {
              title: this.$t('category'),
              type: 'custom-html',
              key: 'category',
              modifier: (value) => {
                  return `<span>${this.$t(value.category_name)}</span>`
              }
          },
          {
            title: this.$t("assigned_to"),
            type: "component",
            key: "users",
            isVisible: true,
            className: "w-100",
            componentName: "group-of-users",
          },
          // {
          //     title: this.$t('assigned_to'),
          //     type: 'custom-html',
          //     key: 'assigned_to',
          //     modifier: (value) => {
          //         return `<span>${this.$t(value)}</span>`
          //     }
          // },
          {
            title: this.$t("start_date"),
            type: "custom-html",
            key: "start_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {

              var result = '';
              let ClassName = "warning";

              const moment = require('moment');
              // Define your due date and current date
              const dueDate = moment(value+' 23:59:59'); // Replace with your due date
              const currentDate = moment(); // Current date and time

              // Calculate the difference in time
              const timeDiff = dueDate.diff(currentDate);
              if (timeDiff > 0) {
                const duration = moment.duration(timeDiff);
                if (duration.days() > 0) {
                  result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                  if(duration.days() > 30) {
                    ClassName = 'success';
                  }
                } else if (duration.hours() > 0) {
                  result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                } else {
                  result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                }
              } else {
                  result = 'The due date has passed.';
                  ClassName = 'danger';
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                result
              )}</span>`;
            },
          },
          {
            title: this.$t("priority"),
            type: "custom-html",
            key: "priority",
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "low") ClassName = `success`;
              else if (value === "medium") ClassName = `warning`;
              else if (value === "high") ClassName = `danger`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "completed") ClassName = `success`;
              else if (value === "incomplete") ClassName = `warning`;
              else if (value === "action_required") {
                ClassName = `info`; value = 'Action Required';}

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("duplicate"),
            icon: "copy",
            type: "none",
            },
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },

          {
            title: this.$t("reminder"),
            icon: "command",
            type: "none",
            component: "task-reminder",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("delete"),
            icon: "trash-2",
            type: "none",
          },
        ],
        filters: [
          {
            title: this.$t("date"),
            type: "range-picker",
            key: "date",
            option: ["today", "thisMonth", "last7Days", "nextYear"],
          },
          {
            title: this.$t("priority"),
            type: "checkbox",
            key: "priority",
            option: [
              { id: "low", value: "Low" },
              { id: "medium", value: "Medium" },
              { id: "high", value: "High" },
            ],
          },
          {
            title: this.$t("status"),
            type: "checkbox",
            key: "status",
            option: [
              { id: "completed", value: "Completed" },
              { id: "incomplete", value: "Incomplete" },
              // {id: 'invited', value: 'Invited'},
            ],
          },
          {
            "title": this.$t('search_by_category'),
            "type": "drop-down-filter",
            "key": "search select",
            "option": [],
          }
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "asc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  mounted() {
    let urlParams = new URLSearchParams(window.location.search);
    if(urlParams.has('status') == true) {
        let status = urlParams.get('status');
        this.options.url = actions.TASK_LISTING+'?status='+status;
    }
  },
  methods: {
    deleteTask(){
      let taskId = this.rowData.id
      let url = actions.DELETE_TASK +'/'+ taskId
      this.deleteLoader = true;
      axiosDelete(url)
          .then((response) => {
            debugger
            this.deleteLoader = false;
            $("#delete-task-confirmation").modal("hide");
            this.cancelled();
            this.$toastr.s(response.data.message);

          })
          .catch((error) => {
            // Trigger after error
            this.$toastr.s(error.data.message);

          })
          .finally(() => {

            this.$hub.$emit("reload-" + this.tableId);
          });
    },
    openCreate() {
      window.location = "tasks/create";
    },
    duplicateTask(taskId){
      let url = actions.CREATE_DUPLICATE_TASK +'/'+ taskId

      let data={
        taskId:taskId
      };
      axiosPost(url, data)
          .then((response) => {
            this.deleteLoader = false;
            this.$toastr.s(response.data.message);

          })
          .catch((error) => {
            // Trigger after error
            this.$toastr.s(error.data.message);

          })
          .finally(() => {
            this.$hub.$emit("reload-" + this.tableId);
          });
    },
    openViewTaskModal() {
      this.isViewTasKModalActive = true;
    },
    closeViewTaskModal() {
      // $("#my_task_modal").modal("hide");
      this.isViewTasKModalActive = false;
      this.searchAndSelectFilterOptions();
    },
    getListAction(rowData, actionObj, active) {
      this.$store.commit('updateSharedData', {index: "taskData", newValue: rowData})
      this.$store.commit('updateSharedData', {index: "taskId", newValue: rowData.id})
       if (actionObj.title == this.$t("edit")) {
        this.$emit('id',rowData.id,2);
      } else if (actionObj.title == this.$t("view")) {
           this.view(rowData.id);
      }else if (actionObj.title == this.$t('reminder')){
        this.openReminderModal(rowData.id);
      }else if (actionObj.title == this.$t('duplicate')){
        this.duplicateTask(rowData.id);
      }else if (actionObj.title == this.$t('delete')){
          this.rowData = rowData;
         this.openDeleteModal();

      }
    },
      view(id) {
        this.id = id;
        this.$store.commit('updateSharedData', {index: "taskId", newValue: id})
        this.$emit('id',id,3);

    },
    myFunction(id){
      let doc = document.getElementById(id);
      if(doc){
        doc.addEventListener('click', () => { 
          this.view(doc.dataset.attribute);
        }) 
      }
    },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.DATATABLE_DATA}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
          this.searchAndSelectFilterOptions();
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    searchAndSelectFilterOptions() {
      this.axiosGet(actions.GET_TASK_CATEGORIES).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_by_category")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
    openReminderModal(task_id){
      this.isTaskReminderModalActive = true;
      this.task_id = task_id;
    },
  },
};
</script>
